import React, { useEffect, useState } from 'react'
import { arrayOf, func, object, string } from 'prop-types'
import { useTranslation } from 'react-i18next'

import styles from './SearchControl.module.scss'

import Icon from '../Icon'
import Spinner from '../Spinner'

const SearchControl = ({
  onChange,
  onSubmit,
  autocompletions,
  setRef,
  suggestions,
  initialValue
}) => {
  // TODO: this logic could likely sit elsewhere and be less convoluted
  const [value, updateValue] = useState(initialValue)
  const [submitted, setSubmitted] = useState(false)
  const { t } = useTranslation()

  const handleChange = (e) => {
    updateValue(e.target.value)
  }

  const handleClick = (e) => {
    updateValue(e.target.textContent)
    setSubmitted(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
  }

  useEffect(() => {
    onChange && onChange(value)

    if (submitted) {
      onSubmit && onSubmit(value)
      setSubmitted(false)
    }
  }, [onChange, onSubmit, submitted, value])

  return (
    <form className={styles.SearchControl} onSubmit={handleSubmit} ref={setRef}>
      <div className={styles.SearchControlControlWrapper}>
        <input
          className={styles.SearchControlControl}
          type="text"
          name="q"
          onChange={handleChange}
          value={value}
          placeholder={t('SearchPlaceholder')}
        />
        <button className={styles.SearchControlSubmit} type="submit">
          {submitted && <Spinner />}
          {!submitted && <Icon type="search" a11yText={t('SearchButton')} />}
        </button>
      </div>
      {(autocompletions.length > 0 || suggestions.length > 0) && (
        <div className={styles.SearchControlListWrapper}>
          {autocompletions.length > 0 && (
            <ul className={styles.SearchControlList}>
              {autocompletions.map((item) => (
                <li key={`autocompletion-${item}`}>
                  <button
                    type="button"
                    onClick={handleClick}
                    className={styles.SearchControlButton}
                  >
                    <Icon type="search" a11yText="" /> {item}
                  </button>
                </li>
              ))}
            </ul>
          )}
          {suggestions.length > 0 && (
            <section>
              <h3 className={styles.SearchControlHeading}>
                {t('SearchSuggestions')}
              </h3>
              <ul className={styles.SearchControlList}>
                {suggestions.map((item) => (
                  <li key={`autocompletion-${item}`}>
                    <button
                      type="button"
                      onClick={handleClick}
                      className={styles.SearchControlButton}
                    >
                      <Icon type="search" a11yText="" /> {item}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          )}
        </div>
      )}
    </form>
  )
}

SearchControl.defaultProps = {
  autocompletions: [],
  suggestions: [],
  initialValue: ''
}

SearchControl.propTypes = {
  onChange: func,
  onSubmit: func,
  autocompletions: arrayOf(string),
  setRef: object,
  suggestions: arrayOf(string),
  initialValue: string
}

export default SearchControl
